import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../environments/environment';

export interface CompanyEmployeeAdminView {
  employeeId: string;
  companyId: number;
  firstName: string | null;
  lastName: string | null;
  nic: string | null;
  email: string | null;
  mobile: string | null;
  status: 'Active' | 'Resigned' | 'Terminated' | 'Suspended';
}

export interface PaginatedCompanyEmployeesAdminViewResponse {
  success: boolean;
  message: string;
  data: {
    employees: CompanyEmployeeAdminView[];
    totalRecords: number;
    pageNumber: number;
    pageSize: number;
    totalPages: number;
    hasPreviousPage: boolean;
    hasNextPage: boolean;
  };
}

@Injectable({
  providedIn: 'root'
})
export class CompanyEmployeesService {
  private readonly apiUrl = `${environment.apiGatewayBaseUrl}/Employees`;

  constructor(private http: HttpClient) {}

  getCompanyEmployeesAdminView(
    pageNumber: number,
    pageSize: number,
    companyId?: number | null,
    employeeId?: string | null,
    status?: string | null
  ): Observable<PaginatedCompanyEmployeesAdminViewResponse> {
    let params = new HttpParams()
      .set('pageNumber', pageNumber)
      .set('pageSize', pageSize);

    if (companyId != null) params = params.set('companyId', companyId);
    if (employeeId)        params = params.set('employeeId', employeeId);
    if (status)            params = params.set('status', status);

    return this.http.get<PaginatedCompanyEmployeesAdminViewResponse>(
      `${this.apiUrl}/admin-view`, { params }
    );
  }
}
